import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['form', 'submitButton', 'select']

  static values = {
    keys: Array
  }

  declare readonly formTarget: HTMLFormElement
  declare readonly submitButtonTarget: HTMLButtonElement
  declare readonly selectTargets: HTMLSelectElement[]
  declare readonly keysValue: string[]

  #formData(): FormData {
    return new FormData(this.formTarget)
  }

  valueChange(): void {
    let shouldEnableSubmit = true
    this.keysValue.forEach(key => {
      if (!this.#formData().has(key)) {
        shouldEnableSubmit = false
      }
    })
    this.submitButtonTarget.disabled = !shouldEnableSubmit
  }

  submitForm(e: SubmitEvent): void {
    e.preventDefault()
    let url = this.formTarget.action
    const payload: Record<string, string> = {}
    this.keysValue.forEach(key => {
      payload[key] = this.#formData().get(key) as string
      url = url.replace(`:${key}`, payload[key])
    })
    document.location.assign(url)
  }
}
